/**
 * AI-artikler gemmes ofte som én lang streng med markdown uden linjeskift.
 * Normaliserer så ReactMarkdown og sektions-parser kan arbejde korrekt.
 */

const HEADING_INLINE = /\s+(#{1,3}\s+)/g

/** Fjern scrape-artefakter (→ !, - !, | Køb…!) fra visningstekst. */
export function stripDisplayArtifacts(text) {
  if (!text?.trim()) return ''
  let s = text
  s = s.replace(/\s*→\s*![.!]*\s*$/gm, '')
  s = s.replace(/\s*→\s*[^\n.]{0,120}!?\s*$/gm, '')
  s = s.replace(/\s*[-–—]\s*!(?=\s|\*|$)/g, '')
  s = s.replace(/\s*[-–—]\s*!\s*$/gm, '')
  s = s.replace(/\s*[|]\s*Køb[^|!]*!?\s*$/gim, '')
  return s.trim()
}

export function normalizeArticleMarkdown(text) {
  if (!text?.trim()) return ''

  let s = stripDisplayArtifacts(text.trim())

  // Linjeskift før overskrifter (### midt i sætning)
  s = s.replace(HEADING_INLINE, '\n\n$1')

  for (const title of ['Introduktion', 'Specs', 'Målgruppe', 'Prisleje']) {
    s = s.replace(new RegExp(`(##\\s+${title})\\s+(?!\\n)`, 'gi'), '$1\n\n')
  }

  // Første linje: **Titel** → ## Titel
  s = s.replace(/^\*\*([^*]+)\*\*/, '## $1')

  // ### **Titel** → ### Titel
  s = s.replace(/^(#{1,3}\s+)\*\*([^*]+)\*\*/gm, '$1$2')

  // Overskrift og brødtekst på samme linje (typisk AI-output uden linjeskift)
  const bodyStart =
    /^(#{1,3}\s+.+?)\s+(Når|Med |Denne |Kernen |Battet |I praksis |For |Det er |Resultatet|Counter Veron|Vertex|Bullpadel)/u
  s = s.replace(bodyStart, '$1\n\n$2')

  // Punktlister efter sætning eller kolon
  s = s.replace(/([.!?…])\s+(-\s+)/g, '$1\n\n$2')
  s = s.replace(/:\s+(-\s+)/g, ':\n\n$1')

  // Afsluttende ødelagte ##
  s = s.replace(/\s+##\s*$/g, '')

  return s.trim()
}

/** Fjern markdown-markup til plain labels (navigation, pills). */
export function stripMarkdownInline(text) {
  if (!text) return ''
  return stripDisplayArtifacts(
    String(text)
      .replace(/\*\*([^*]+)\*\*/g, '$1')
      .replace(/\*([^*]+)\*/g, '$1')
      .replace(/^#{1,6}\s+/gm, '')
  )
}
